export let Weekday = /*#__PURE__*/function (Weekday) {
  Weekday[Weekday["Sunday"] = 0] = "Sunday";
  Weekday[Weekday["Monday"] = 1] = "Monday";
  Weekday[Weekday["Tuesday"] = 2] = "Tuesday";
  Weekday[Weekday["Wednesday"] = 3] = "Wednesday";
  Weekday[Weekday["Thursday"] = 4] = "Thursday";
  Weekday[Weekday["Friday"] = 5] = "Friday";
  Weekday[Weekday["Saturday"] = 6] = "Saturday";
  return Weekday;
}({});
export function createWeekdayFilter(weekday) {
  // NOTE: Array.isArray does not work on readonly arrays correctly in TS 3.8
  return Array.isArray(weekday) ? day => weekday.includes(day.getDay()) : day => weekday === day.getDay();
}
export const isPastDate = (day, {
  today
}) => {
  if (day.getFullYear() < today.getFullYear()) {
    return true;
  } else if (day.getFullYear() > today.getFullYear()) {
    return false;
  } else if (day.getMonth() < today.getMonth()) {
    return true;
  } else if (day.getMonth() > today.getMonth()) {
    return false;
  } else if (day.getDate() < today.getDate()) {
    return true;
  } else {
    return false;
  }
};
export const isAfterDate = (day, {
  today
}) => {
  if (day.getFullYear() > today.getFullYear()) {
    return true;
  } else if (day.getFullYear() < today.getFullYear()) {
    return false;
  } else if (day.getMonth() > today.getMonth()) {
    return true;
  } else if (day.getMonth() < today.getMonth()) {
    return false;
  } else if (day.getDate() > today.getDate()) {
    return true;
  } else {
    return false;
  }
};
export function combineFilters(filters) {
  return (day, ctx) => filters.some(filter => filter(day, ctx));
}
export function createDisabledDayFilter(config) {
  const filters = [];
  if (config.weekdays) {
    filters.push(createWeekdayFilter(config.weekdays));
  }
  if (config.pastDates) {
    filters.push(isPastDate);
  }
  return combineFilters(filters);
}
//# sourceMappingURL=DisabledDayFilters.js.map